import React, { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { PoseGroup } from 'react-pose';
import SideSlideAnimation from '~components/SideSlideAnimation';
import { Overlay } from './styledComponents';

export type Props = {
  isOpen: boolean;
  showPopup: void;
  duration: number;
  side: 'left' | 'right';
  children: React.ReactNode;
  onClose: () => void;
  className?: string;
};

// use as styled-component to set width
const Sidebar = ({
  children,
  duration,
  isOpen,
  side,
  className,
  onClose,
}: Props) => {
  const rootNodeRef = useRef(document.createElement('div'));
  const rootNodeChildRef = useRef(document.createElement('div'));

  useEffect(() => {
    document.body.appendChild(rootNodeRef.current);
    rootNodeRef.current.appendChild(rootNodeChildRef.current);

    return () => {
      rootNodeRef.current.remove();
    };
  }, []);

  const elem = (
    <PoseGroup>
      {isOpen && (
        <Overlay key='overlay'>
          <SideSlideAnimation
            duration={duration}
            side={side}
            className={className}
            onClose={onClose}
          >
            {children}
          </SideSlideAnimation>
        </Overlay>
      )}
    </PoseGroup>
  );

  return createPortal(elem, rootNodeChildRef.current);
};

export default Sidebar;
